export default function AboutBanner() {
	return <div className="aboutBackground wh-msk"></div>;
}
